<template>
  <v-container fluid v-if="settings">
    <v-card outlined>
      <v-container fluid>
        <validation-observer ref="form">
          <v-form>
            <v-card outlined class="mb-5">
              <v-card-title class="justify-center text-uppercase">ship from store standard</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col cols="6" sm="9" md="9" lg="10">
                    <v-switch
                      class="mt-0"
                      v-model="settings.ship_from_store_min_basket.activated"
                      label="PANIER MINIMUM"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="3"
                    md="3"
                    lg="2"
                    v-if="settings.ship_from_store_min_basket.activated"
                  >
                    <validation-provider
                      :rules="'check_max_value_basket:'+settings.ship_from_store_max_basket.value+','
                        +settings.ship_from_store_max_basket.activated
                        +'|numeric|required'"
                      name="minimum basket ship from store"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        dense
                        v-model="settings.ship_from_store_min_basket.value"
                        type="number"
                        :error-messages="errors"
                        required
                        append-outer-icon="mdi-currency-eur"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="9" md="9" lg="10">
                    <v-switch
                      class="mt-0"
                      v-model="settings.ship_from_store_max_basket.activated"
                      label="PANIER MAXIMUM"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="3"
                    md="3"
                    lg="2"
                    v-if="settings.ship_from_store_max_basket.activated"
                  >
                    <validation-provider
                      :rules="'check_min_value_basket:'+settings.ship_from_store_min_basket.value+','
                        +settings.ship_from_store_min_basket.activated
                        +'|numeric|required'"
                      name="maximum basket ship from store"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        dense
                        v-model="settings.ship_from_store_max_basket.value"
                        type="number"
                        :error-messages="errors"
                        required
                        append-outer-icon="mdi-currency-eur"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-card outlined class="mb-5">
              <v-card-title class="justify-center text-uppercase">ship from store express</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col cols="6" sm="9" md="9" lg="10">
                    <v-switch
                      class="mt-0"
                      v-model="settings.ship_from_store_express_min_basket.activated"
                      label="PANIER MINIMUM"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="3"
                    md="3"
                    lg="2"
                    v-if="settings.ship_from_store_express_min_basket.activated"
                  >
                    <validation-provider
                      :rules="
                        'check_max_value_basket:'+settings.ship_from_store_express_max_basket.value+','
                            +settings.ship_from_store_express_max_basket.activated
                            +'|numeric|required'"
                      name="minimum basket ship from store express"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        dense
                        v-model="settings.ship_from_store_express_min_basket.value"
                        type="number"
                        :error-messages="errors"
                        required
                        append-outer-icon="mdi-currency-eur"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="9" md="9" lg="10">
                    <v-switch
                      class="mt-0"
                      v-model="settings.ship_from_store_express_max_basket.activated"
                      label="PANIER MAXIMUM"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="3"
                    md="3"
                    lg="2"
                    v-if="settings.ship_from_store_express_max_basket.activated"
                  >
                    <validation-provider
                      :rules="'check_min_value_basket:'+settings.ship_from_store_express_min_basket.value+','
                        +settings.ship_from_store_express_min_basket.activated
                        +'|numeric|required'"
                      name="maximum basket ship from store express"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        dense
                        v-model="settings.ship_from_store_express_max_basket.value"
                        type="number"
                        :error-messages="errors"
                        required
                        append-outer-icon="mdi-currency-eur"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-card outlined class="mb-5">
              <v-card-title class="justify-center text-uppercase">disponibilité des produits</v-card-title>
              <v-container fluid>
                <v-switch
                  v-model="settings.allow_partial_handling"
                  class="text-uppercase"
                  label="Prendre en compte dans l'attribution d'une livraison uniquement les magasins détenant l'intégralité des produits de la commande"
                ></v-switch>
              </v-container>
            </v-card>
            <!-- <v-card outlined>
              <v-card-title class="justify-center text-uppercase">gestion des seuils</v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-card-text
                      class="text-uppercase pt-0"
                    >définir les stocks minimum acceptés pour les produits</v-card-text>
                    <v-card-text
                      class="text-uppercase pb-0"
                    >* la note de fréquentation des magasins est par défaut définie à 1.</v-card-text>
                    <v-card-text class="text-uppercase pt-0">Contactez octipas pour la modifier</v-card-text>
                  </v-col>
                  <v-col cols="6">COMPLEXE OBJECT</v-col>
                </v-row>
              </v-container>
            </v-card>-->
            <v-row justify="center">
              <v-btn
                class="ma-2 text-uppercase"
                color="primary"
                outlined
                @click="validate"
              >enregistrer</v-btn>
            </v-row>
          </v-form>
        </validation-observer>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric } from "vee-validate/dist/rules";
extend("check_max_value_basket", {
  validate(value, { max, active }) {
    if (active == "true" && value >= 0) {
      return value <= parseInt(max);
    } else {
      return value >= 0;
    }
  },
  message: (fieldName, placeHolders) => {
    if (placeHolders.active == "true" && parseInt(placeHolders._value_) >= 0) {
      return `min > max `;
    } else {
      return `minimum < 0 `;
    }
  },
  params: ["max", "active"]
});
extend("check_min_value_basket", {
  validate(value, { min, active }) {
    if (active == "true" && value >= 0) {
      return value >= parseInt(min);
    } else {
      return value >= 0;
    }
  },
  message: (fieldName, placeHolders) => {
    if (placeHolders.active == "true" && parseInt(placeHolders._value_) >= 0) {
      return `max < min `;
    } else {
      return `maximum < 0 `;
    }
  },
  params: ["min", "active"]
});
extend("numeric", { ...numeric })

export default {
  name: "ProductsSettings",
  components: {
    "validation-provider": ValidationProvider,
    "validation-observer": ValidationObserver
  },
  data() {
    return {
      settings: false
    };
  },
  mounted: function() {
    this.list();
  },
  methods: {
    list: function() {
      //todo: load settings when API is ready
      var loadedSettings = {
        ship_from_store_min_basket: {
          activated: false,
          value: 0
        },
        ship_from_store_max_basket: {
          activated: false,
          value: 0
        },
        ship_from_store_express_min_basket: {
          activated: false,
          value: 0
        },
        ship_from_store_express_max_basket: {
          activated: false,
          value: 0
        },
        allow_partial_handling: false
      };
      this.settings = loadedSettings;
    },
    validate() {
      this.$refs.form.validate().then(success => {
        if (success) {
          console.log(this.settings);
          console.log("update settings");
        }
      });
    }
  }
};
</script>